import React from 'react';
import { useTranslation } from 'react-i18next';
import { LANGS, LANG_LABEL, LANG_NAME, currentLang, setLanguage } from './index';
import { apiClient } from '../api/client';
import { SegTabs } from '../ui/SegTabs';

/**
 * Переключатель языка интерфейса: RU / UA.
 *
 * Выбор запоминается в браузере и, если человек вошёл, в его настройках на
 * сервере — по ним сервер выбирает язык уведомлений в Telegram. Запись на
 * сервер не ждём дольше секунды: страница всё равно перезагрузится, а язык
 * интерфейса от сервера не зависит.
 */
export const LanguageSwitcher: React.FC<{ className?: string; compact?: boolean }> = ({ className, compact }) => {
  const { t } = useTranslation('common');
  const cur = currentLang();

  const pick = async (lang: typeof LANGS[number]) => {
    if (lang === cur) return;
    if (localStorage.getItem('access_token')) {
      try {
        await Promise.race([
          apiClient.raw.put('/api/settings', { language: lang }),
          new Promise(res => setTimeout(res, 1000)),
        ]);
      } catch { /* сервер недоступен — язык интерфейса сменим всё равно */ }
    }
    setLanguage(lang);
  };

  // Таблетка с ползущим индикатором — как вкладки шапки.
  return (
    <div role="group" aria-label={t('language.label')} title={t('language.label')} className={className}>
      <SegTabs accent value={cur} onChange={l => void pick(l)}
        btnClassName={compact ? '!h-6 !px-2 !text-[11px] font-semibold' : '!h-7 !px-2.5 !text-xs font-semibold'}
        items={LANGS.map(l => ({ key: l, label: LANG_LABEL[l], title: LANG_NAME[l] }))} />
    </div>
  );
};

export default LanguageSwitcher;
